import type { Component } from 'vue';
import BlockCenter from './BlockCenter.vue';
import DictCard from './DictCard.vue';
import Page from './Page.vue';
import TitleBlock from './TitleBlock.vue';

export default new Map<string, Component>([
  ['TitleBlock', TitleBlock],
  ['BlockCenter', BlockCenter],
  ['Page', Page],
  ['DictCard', DictCard],
]);



